import getEnvVar from './utils/getEnvVar';

// Amplify only builds its OAuth handler when redirectSignIn is defined, so an undefined value here
// silently disables hosted-UI sign-in until the user clicks. Falling back to the serving origin
// keeps every environment self-configuring.
const withTrailingSlash = (url: string): string => (url.endsWith('/') ? url : `${url}/`);

const REDIRECT_URI = withTrailingSlash(
  getEnvVar('VITE_REDIRECT_AUTO_DETECT') === 'true'
    ? window.location.origin
    : getEnvVar('VITE_REDIRECT_URI') || window.location.origin,
);
const config = {
  Auth: {
    userPoolId: getEnvVar('VITE_COGNITO_USER_POOL_ID'),
    region: getEnvVar('VITE_COGNITO_REGION'),
    userPoolWebClientId: getEnvVar('VITE_COGNITO_CLIENT_ID'),
    oauth: {
      domain: getEnvVar('VITE_COGNITO_DOMAIN'),
      scope: ['phone', 'email', 'profile', 'openid'],
      redirectSignIn: REDIRECT_URI,
      redirectSignOut: REDIRECT_URI,
      responseType: 'code',
    },
  },
};

export default config;
